import Vue from 'vue';
import Vuex from 'vuex';
import { vuexfireMutations, firestoreAction } from 'vuexfire';
import { db } from '../db';
import modules from './modules';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules,
  state: {
    jobs: [],
  },
  mutations: {
    ...vuexfireMutations,

    addJob(state, data) {
      state.jobs.push(data);
    },
  },
  actions: {
    bindJobs: firestoreAction(({ bindFirestoreRef }) =>
      bindFirestoreRef('jobs', db.collection('jobs'))),

    addJob({ commit }, data) {
      db.collection('jobs').add(data)
        .then((docRef) => {
          commit('addJob', docRef);
        })
        .catch((error) => {
          console.error('Error adding document: ', error);
        });
    },
  },
  getters: {
    getJobs(state) {
      return state.jobs;
    },
  },
});

const prepareHotModuleReloading = () => {
  module.hot.accept(['./modules'], () => {
    store.hotUpdate({ modules: modules.default });
  });
};

if (module.hot) { prepareHotModuleReloading(); }

export default store;
